import React, { useEffect, useState } from "react";
import "../../modal.css";

export default function HealthMultiplePlanSelection({ planList, selectedPlanIds, SelectPlan, handleSubmit, insurerList, selectedInsurer, setSelectedInsurer, selectedPlans, removePlan, SearchPlan, SearchInsurer }) {

  return (
    <div className={`planSelection ${selectedPlanIds.length >= 1 ? "active" : null}`}>
      <section className="insurer_selection">
        <div className="filter">

        </div>

        {selectedInsurer ?
          <div className="planselect">
            <div className="heading-insuer-selection" >
              <div className="backbutton" onClick={() => {
                setSelectedInsurer()
                SearchInsurer('')
              }}>{"<"}</div>
              {" Select Plan Insurer Wise"}
            </div>
            <div class="filter">
              <input type="text" name="searchPlan" value={null} id='searchPlan' placeholder="Search Plan" onChange={(event) => SearchPlan(event.target.value)} />
            </div>
            <section>
              {planList ? planList.map((item) =>
                <>
                  {item.supplier_id === selectedInsurer ?
                    <label className="radio-button-container"  >{item.plan_name}
                      <input type="checkbox" checked={selectedPlanIds.includes(item.plan_id)} disabled={!selectedPlanIds.includes(item.plan_id) && selectedPlanIds.length >= 2} onClick={(event) => SelectPlan(item, event.target.checked)} name="radio" />
                      <span className="checkmark"></span>
                    </label>
                    : null}
                </>
              ) : null}
            </section>

          </div>
          :
          <div className="insurer_select">
            <div className="heading-insuer-selection">
              Select Insurser
            </div>
            <div class="filter">
              <input type="text" id="searchInsurer" value={null} placeholder="Search Insurer" onChange={(event) => SearchInsurer(event.target.value)} />
            </div>
            <div className="list_of_insurer">
              {insurerList ? Object.values(insurerList).sort((a, b) => a.supplier_name.localeCompare(b.supplier_name, undefined, { caseFirst: "upper" })).map((item) =>
                <div className="logo_insurer" onClick={() => {
                  setSelectedInsurer(item.supplier_id)
                  SearchInsurer('')
                }}> <div className="logoimg"><img src={item.ImageUrl} /> </div><p>{item.supplier_name}</p> </div>
              ) : null}
            </div>
          </div>
        }

      </section>
      <div className={`compare-btn-wrapper ${selectedPlanIds.length >= 1 ? "active" : null}`} >
        <div className="headingText">Select plans</div>
        <div className="planselection">
          <div className="selectedPlan">
            <div className="pp">
              <div className="planbox plan_a">

                {selectedPlans.length >= 1 ?
                  <>
                    <img src={selectedPlans[0].ImageUrl} />
                    <span className="close" onClick={() => removePlan(selectedPlans[0])}></span>
                  </>
                  : <label>
                    Select Plan
                  </label>}
              </div>
              <span>{selectedPlans && selectedPlans[0] ? selectedPlans[0].plan_name : null}</span>
            </div>
            <div className="pp">
              <div className="planbox plan_b">

                {selectedPlans.length === 2 ?
                  <>
                    <img src={selectedPlans[1].ImageUrl} />
                    <span className="close" onClick={() => removePlan(selectedPlans[1])}></span>
                  </>
                  : <label>
                    Select Plan
                  </label>}
              </div>
              <span>{selectedPlans && selectedPlans[1] ? selectedPlans[1].plan_name : null}</span>
            </div>
          </div>
          <div className="compare-btn disable" onClick={() => handleSubmit()} >
            <span>{"Compare ›"}</span>
          </div>
        </div>
      </div>
    </div >

  );
}


